// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  scheduledId: __t.u64().primaryKey().name("scheduled_id"),
  scheduledAt: __t.scheduleAt().name("scheduled_at"),
  attackerKey: __t.string().name("attacker_key"),
  targetKind: __t.string().name("target_kind"),
  targetPlayer: __t.identity().name("target_player"),
  targetVersona: __t.u64().name("target_versona"),
  dmg: __t.i32(),
  reachM: __t.f32().name("reach_m"),
  x: __t.f32(),
  z: __t.f32(),
  windupStartedAt: __t.timestamp().name("windup_started_at"),
  windupMs: __t.u32().name("windup_ms"),
});
